export default __webpack_public_path__ + "static/media/exitSelected.fdfbe251.svg";